export default {
      id: "camera-usage",
      viewBox: "0 0 13.789 13.778",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#camera",
      toString: function () {
        return this.url;
      }
    }